import styled from 'styled-components';
import { Menu, MenuItem, MenuMenu } from 'semantic-ui-react';
import COLORS from 'constants/colors';
import { FlexView } from '@cuemath/comps';

export const Root = styled(FlexView)`
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const CustomeMenu = styled(Menu)`
  height: 100%;
  width: 100%;
  border-bottom: none !important;
  padding: 0 16px;
`;

export const DefaultMenuItem = styled(MenuItem)`
  width: 32px;
  height: 32px;
  border-radius: 8px !important;
  display: flex;
  justify-content: center;
`;

export const DefaultMenu = styled(CustomeMenu)`
  margin: 0;
`;

export const MenuItemStyle = {
  margin: 0,
  padding: '0 24px',
  height: '100%',
  color: COLORS.FONT,
};

export const IconMenu = styled(MenuMenu)`
  align-items: center;
`;

export const VerticleSeperator = styled.span`
  margin: 0 12px;
  border-right: 1px solid #e0e0e0;
  height: 20px;
`;
